import axios from "axios"

axios.defaults.baseURL = "https://api.themoviedb.org/3"

export const fetchPopularMovies = (page: number) => {
  return axios.get(
    `/movie/popular?api_key=${process.env.REACT_APP_MOVIEDB_TOKEN}&language=en-US&page=${page}`
  )
}

export const fetchMovieDetails = (id: string) => {
  return axios.get(
    `/movie/${id}?api_key=${process.env.REACT_APP_MOVIEDB_TOKEN}&language=en-US&page=1`
  )
}

export const searchMovies = async (searchValue: string) => {
  return await axios.get(
    `/search/movie?api_key=${process.env.REACT_APP_MOVIEDB_TOKEN}&language=en-US&query=${searchValue}&include_adult=false`
  )
}
